module.exports = __webpack_public_path__ + "static/media/payportal.1b9f4e1e.png";